import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'
import './styles/common.scss'
import store from '@/store'
import './permission'
import App from './App'
// OSS上传组件
import OssPictureUpload from '@/components/OssPictureUpload'
import OssFileUpload from '@/components/OssFileUpload'
import Pagination from '@/components/Pagination'
import {COMPET_THEME,COMPET_CLASSIFY_ID} from '@/utils/config.js'
import { selectDictLabel, download } from '@/utils/index'
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.download = download

Vue.use(ElementUI);
Vue.component('OssPictureUpload', OssPictureUpload)
Vue.component('OssFileUpload', OssFileUpload)
Vue.component('Pagination', Pagination)
Vue.config.productionTip = false
Vue.prototype.competId = store.state.user.competId || localStorage.getItem('comprtId')
Vue.prototype.competTheme = COMPET_THEME
Vue.prototype.competClassIfyId = COMPET_CLASSIFY_ID

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js